const { hostname } = window.location
const BASE = hostname === 'localhost' || hostname === '127.0.0.1'
  ? 'http://localhost:3000/api'
  : hostname === 'quotastic.ca'
    ? 'https://api.quotastic.ca/api'
    : 'https://api-staging.quotastic.ca/api'

/**
 * Fire-and-forget action logger. Never throws.
 * @param {string|null} token  Firebase ID token from getAuthToken()
 * @param {{ action: string, label?: string, metadata?: object, company_id?: string }} opts
 */
export function logAction(token, { action, label, metadata, company_id } = {}) {
  if (!token || !action) return
  fetch(`${BASE}/logs`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ action, label, metadata, company_id }),
  }).catch(() => {})
}
